import React from "react";
import { useNavigate } from "react-router-dom";

const UpgradeFozzilButton = () => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate("/pricing");
  };

  return (
    <div className="flex flex-col items-center justify-center mt-8 mb-6">
      {/* Description and Button on same line */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 max-w-[800px] w-full">
        <p className="text-white text-base sm:text-lg font-secondary text-center sm:text-left leading-relaxed flex-1">
          Unlock the power of AGI with the FOZZIL Blacksite Plan. This is more
          than an upgrade; it's a complete transformation of your experience.
        </p>

        {/* Smaller Upgrade Button */}
        <button
          onClick={handleUpgradeClick}
          className="upgrade-fozzil-btn text-white font-secondary font-semibold text-sm px-6 py-2.5 rounded-full border border-white cursor-pointer transition-all duration-300 ease-in-out hover:transform hover:-translate-y-1 hover:shadow-lg uppercase tracking-wide whitespace-nowrap"
        >
          Upgrade FOZZIL
        </button>
      </div>

      <style jsx>{`
        .upgrade-fozzil-btn {
          position: relative;
          background: transparent;
          border: 1px solid white;
        }

        .upgrade-fozzil-btn:hover {
          border: 1px solid transparent;
          background: linear-gradient(transparent, transparent) padding-box,
            linear-gradient(90deg, #0099f2 0%, #1a6dff 50%, #c822ff 100%)
              border-box;
          background-clip: padding-box, border-box;
          box-shadow: 0 6px 20px rgba(0, 153, 242, 0.4) !important;
        }
      `}</style>
    </div>
  );
};

export default UpgradeFozzilButton;
